// @ts-check
import {
  INPUT_CHANGED
} from '../../../redux/actions/actionTypes';
import { buildingType } from '../../common/constants';
import { validationType } from './validationConstants';

const initialValidationState = {
  plot_dimension_x: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 10 to 200',
    errTextFt: 'Enter a value between 30 to 650'
  },
  plot_dimension_y: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 10 to 200',
    errTextFt: 'Enter a value between 30 to 650'
  },
  house_plot_size: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 3 to 40',
    errTextFt: 'Enter a value between 10 to 130',
  },
  house_plot_size_second: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: "This house plot is too big and can't fit. Please make it make it smaller?"
  },
  flat_depth: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 3 to 10',
    errTextFt: 'Enter a value between 10 to 30',
  },
  floor_height: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 3 to 5',
    errTextFt: 'Enter a value between 10 to 16',
  },
  floors_number: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 1 to 50'
  },
  floor_area: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Floor area values must be between 30 to 180',
    errTextFt: 'Floor area values must be between 300 to 2000',
  },
  unique_floor_area: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Floor area must be unique'
  },
  unit_type: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Unit Type required'
  },
  unique_unit_type: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Unit Type must be unique'
  },
  storeys: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Storeys values must be between 1 to 5'
  },
  house_width: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Width values must be between 3 to 10',
    errTextFt: 'Width values must be between 10 to 30',
  },
  floors_number_perpendicular: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 1 to 50'
  },
  distance_between_vertical_cores: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter a value between 20 to 40',
    errTextFt: 'Enter a value between 65 to 130',
  },
  I_building_dimensions: {
    validationType: validationType.MULTI_FIELD,
    valid: true,
    errText: 'Please increase your plot size'
  },
  L_building_dimensions: {
    validationType: validationType.MULTI_FIELD,
    valid: true,
    errText: 'Please increase your plot size'
  },
  O_building_dimensions: {
    validationType: validationType.MULTI_FIELD,
    valid: true,
    errText: '4 X Flat depth + 2 X Corridor width + 22 cannot exceed plot dimensions'
  },
  road_width: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter value between 2 to 20',
    errTextFt: 'Enter value between 7 to 65'
  },
  distance_from_road: {
    validationType: validationType.INPUT_FIELD,
    valid: true,
    errText: 'Enter value between 0 to 5',
    errTextFt: 'Enter value between 0 to 15',
  }
}

const is_I_BuildingValid = (globalFormState) => {
  const bInfo = globalFormState.buildingInfo
  if (bInfo.building_type !== buildingType.I) {
    return true
  }

  const shortEdge = Math.min(parseFloat(bInfo.plot_length), parseFloat(bInfo.plot_width))

  const flatDepth = parseFloat(bInfo.flat_depth)
  const corridorWidth = parseFloat(bInfo.corridor_width)

  return shortEdge > (2 * flatDepth) + corridorWidth
}

const is_L_BuildingValid = (globalFormState) => {
  const bInfo = globalFormState.buildingInfo

  if (bInfo.building_type !== buildingType.L) {
    return true
  }

  const shortEdge = Math.min(parseFloat(bInfo.plot_length), parseFloat(bInfo.plot_width))

  const flatDepth = parseFloat(bInfo.flat_depth)
  const corridorWidth = parseFloat(bInfo.corridor_width)

  return shortEdge > (2 * flatDepth) + corridorWidth
}

const is_O_BuildingValid = (globalFormState) => {
  const bInfo = globalFormState.buildingInfo
  if (bInfo.building_type !== buildingType.O) {
    return true
  }

  const shortEdge = Math.min(parseFloat(bInfo.plot_length), parseFloat(bInfo.plot_width))

  const flatDepth = parseFloat(bInfo.flat_depth)
  const corridorWidth = parseFloat(bInfo.corridor_width)

  return shortEdge > (4 * flatDepth) + (2 * corridorWidth) + 22
}

const isFlatAreaValidForAll = (globalFormState) => {
  for (const ut of globalFormState.buildingInfo.unit_types) {
    if (globalFormState.buildingInfo.units === 'm' && (ut.floor_area < 30 || ut.floor_area > 180)) {
      return false
    }
    if (globalFormState.buildingInfo.units === 'ft' && (ut.floor_area < 300 || ut.floor_area > 2000)) {
      return false
    }
  }
  return true
}
const isFloorAreaUniqueForAll = (globalFormState) => {
  const ut = globalFormState.buildingInfo.unit_types.map(r => r.floor_area)
  const sut = new Set(ut)
  if (ut.length === sut.size) return true

  return false
}

const isUnitTypeValidForAll = (globalFormState) => {
  for (const ut of globalFormState.buildingInfo.unit_types) {
    if (ut.name.trim().length === 0) {
      return false
    }
  }

  return true
}
const isUnitTypeUniqueForAll = (globalFormState) => {

  const names = globalFormState.buildingInfo.unit_types.map(r => r.name)
  const snames = new Set(names)
  if (names.length === snames.size) return true
  return false
}
const ishousePlotSizeValid = (globalFormState) => {
  if (globalFormState.buildingInfo.units === 'm') {
    if (!(globalFormState.buildingInfo.minimal_block_depth >= 3) || !(globalFormState.buildingInfo.minimal_block_depth <= 40)) {
      return false
    }
    if (!(globalFormState.buildingInfo.minimal_block_width >= 3) || !(globalFormState.buildingInfo.minimal_block_width <= 40)) {
      return false
    }
    return true;
  }
  if (globalFormState.buildingInfo.units === 'ft') {
    if (!(globalFormState.buildingInfo.minimal_block_depth >= 10) || !(globalFormState.buildingInfo.minimal_block_depth <= 130)) {
      return false
    }
    if (!(globalFormState.buildingInfo.minimal_block_width >= 10) || !(globalFormState.buildingInfo.minimal_block_width <= 130)) {
      return false
    }
    return true;
  }

  return true
}

const ishousePlotSizeSecondValid = (globalFormState) => {

  const plotDimention = [+globalFormState.buildingInfo.plot_length, +globalFormState.buildingInfo.plot_width]
  const housePlotSize = [+globalFormState.buildingInfo.minimal_block_depth, +globalFormState.buildingInfo.minimal_block_width]

  if (!(housePlotSize[0] <= plotDimention[0]) || !(housePlotSize[1] <= plotDimention[1])) {
    return false
  }
  return true;

}

const isStoreysValidForAll = (globalFormState) => {
  const bInfo = globalFormState.buildingInfo;
  for (const ut of bInfo.unit_types) {
    if (bInfo.building_type === "H" && (ut.storeys < 1 || ut.storeys > 5)) {
      return false
    }
  }

  return true
}

const isHouseWidthValidForAll = (globalFormState) => {
  const bInfo = globalFormState.buildingInfo;
  const units = globalFormState.units;
  if (units === 'm' && bInfo.building_type === "H") {

    for (const ut of bInfo.unit_types) {
      if (ut.house_width < 3 || ut.house_width > 10) {
        return false
      }
      if (!ut.house_width) {
        return false
      }
    }
  }
  if (units === 'ft' && bInfo.building_type === "H") {

    for (const ut of bInfo.unit_types) {
      if (ut.house_width < 10 || ut.house_width > 30) {
        return false
      }
      if (!ut.house_width) {
        return false
      }
    }
  }


  return true
}

const recalculateValidation = (validationState, rootState) => {
  const validationStateClone = Object.assign({}, validationState)
  const globalFormState = rootState.globalFormData
  Object.keys(validationStateClone).forEach(key => {
    switch (key) {
      case 'plot_dimension_x': {
        const val = parseFloat(globalFormState.buildingInfo.plot_length)
        if (globalFormState.buildingInfo.units === 'm') {
          validationStateClone.plot_dimension_x.valid = (val > 10 && val <= 200)
        }
        if (globalFormState.buildingInfo.units === 'ft') {
          validationStateClone.plot_dimension_x.valid = (val > 30 && val <= 650)
        }
      }
        break
      case 'plot_dimension_y': {
        const val = parseFloat(globalFormState.buildingInfo.plot_width)
        if (globalFormState.buildingInfo.units === 'm') {
          validationStateClone.plot_dimension_y.valid = (val > 10 && val <= 200)
        }
        if (globalFormState.buildingInfo.units === 'ft') {
          validationStateClone.plot_dimension_y.valid = (val > 30 && val <= 650)
        }
      }
        break
      case 'house_plot_size': {
        validationStateClone.house_plot_size.valid = ishousePlotSizeValid(globalFormState)
      }
        break
      case 'house_plot_size_second': {
        validationStateClone.house_plot_size_second.valid = ishousePlotSizeSecondValid(globalFormState)
      }
        break
      case 'floor_height': {
        if (globalFormState.buildingInfo.units === 'm') {
          const val = parseFloat(globalFormState.buildingInfo.floor_height)
          validationStateClone.floor_height.valid = (val >= 3 && val <= 5)
        }
        if (globalFormState.buildingInfo.units === 'ft') {
          const val = parseFloat(globalFormState.buildingInfo.floor_height)
          validationStateClone.floor_height.valid = (val >= 10 && val <= 16)
        }
      }
        break
      case 'flat_depth': {
        const val = parseFloat(globalFormState.buildingInfo.flat_depth)
        if (globalFormState.units === 'm') {
          validationStateClone.flat_depth.valid = (val >= 3 && val <= 10)
        }
        if (globalFormState.units === 'ft') {
          validationStateClone.flat_depth.valid = (val >= 10 && val <= 30)
        }
      }
        break
      case 'floors_number': {
        const val = parseFloat(globalFormState.buildingInfo.floors_number)
        validationStateClone.floors_number.valid = (val > 0 && val <= 50)
      }
        break
      case 'floor_area': {
        validationStateClone.floor_area.valid = isFlatAreaValidForAll(globalFormState)
      }
        break
      case 'unique_floor_area': {
        validationStateClone.unique_floor_area.valid = isFloorAreaUniqueForAll(globalFormState)
      }
        break
      case 'unit_type': {
        validationStateClone.unit_type.valid = isUnitTypeValidForAll(globalFormState)
      }
        break
      case 'unique_unit_type': {
        validationStateClone.unique_unit_type.valid = isUnitTypeUniqueForAll(globalFormState)
      }
        break
      case 'storeys': {
        validationStateClone.storeys.valid = isStoreysValidForAll(globalFormState)
      }
        break
      case 'house_width': {
        validationStateClone.house_width.valid = isHouseWidthValidForAll(globalFormState)
      }
        break
      case 'floors_number_perpendicular': {
        const val = parseFloat(globalFormState.buildingInfo.floors_number_perpendicular)
        validationStateClone.floors_number_perpendicular.valid = (val > 0 && val <= 50)
      }
        break
      case 'distance_between_vertical_cores': {
        const val = parseFloat(globalFormState.buildingInfo.distance_between_vertical_cores)
        if (globalFormState.units === 'm') {
          validationStateClone.distance_between_vertical_cores.valid = (val >= 20 && val <= 40)
        }
        if (globalFormState.units === 'ft') {
          validationStateClone.distance_between_vertical_cores.valid = (val >= 65 && val <= 130)
        }
      }
        break
      case 'I_building_dimensions': {
        validationStateClone.I_building_dimensions.valid = is_I_BuildingValid(globalFormState)
      }
        break
      case 'L_building_dimensions': {
        validationStateClone.L_building_dimensions.valid = is_L_BuildingValid(globalFormState)
      }
        break
      case 'O_building_dimensions': {
        validationStateClone.O_building_dimensions.valid = is_O_BuildingValid(globalFormState)
      }
        break

      case 'road_width': {
        if (globalFormState.buildingInfo.units === 'm') {
          const val = parseFloat(globalFormState.buildingInfo.road_width)
          validationStateClone.road_width.valid = (val >= 2 && val <= 20)
        } else {
          const val = parseFloat(globalFormState.buildingInfo.road_width)
          validationStateClone.road_width.valid = (val >= 7 && val <= 65)
        }
      }
        break

      case 'distance_from_road': {
        if (globalFormState.buildingInfo.units === 'm') {
          const val = parseFloat(globalFormState.buildingInfo.distance_from_road)
          validationStateClone.distance_from_road.valid = (val >= 0 && val <= 5)
        } else {
          const val = parseFloat(globalFormState.buildingInfo.distance_from_road)
          validationStateClone.distance_from_road.valid = (val >= 0 && val <= 15)

        }
      }
        break

      default:
        throw new Error(`invalid validation key ${key}`)
    }
  })

  return validationStateClone
}

function validationReducer(validationState = initialValidationState, action) {
  switch (action.type) {
    case INPUT_CHANGED:
      return recalculateValidation(validationState, action.payload.rootState)
    default:
      return validationState;
  }

}

export default validationReducer